import React from "react";
import CssClasses from "./TicketTypeButton.css";
import SiteIcons from "../../../assets/fonts/site_icons/style.css";

const TicketTypeButton = props => {
  let classes = [CssClasses.button];

  if (props.isActive) {
    classes.push(CssClasses.active);
  }

  return (
    <div
      onClick={() => {
        props.onButtonClicked(props.id);
      }}
      className={classes.join(" ")}
    >
      <span className={CssClasses.title}>{props.title}</span>

      {props.isActive ? (
        <span
          className={[SiteIcons.site_icon_triangle, CssClasses.triangle].join(
            " "
          )}
        />
      ) : null}
    </div>
  );
};

export default TicketTypeButton;



// WEBPACK FOOTER //
// ./src/Components/UI/TicketTypeButton/TicketTypeButton.js